export const FacebookDeveloperId = process.env.GAMIPHY_ENV === 'prod' ? '2707045519523927' : '374595980291964';
export const InstagramAppId = process.env.GAMIPHY_ENV === 'prod' ? '315568946158561' : '3520998054687960';
export const NATUrl = 'https://static.gamiphy.co/fe/utils/natv2/index.html';
